import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import { ConsolidatedView } from '../../../components/group-steering/ConsolidatedView'

export const Route = createFileRoute('/$org/group/')({
    component: ConsolidatedRoute,
})

function ConsolidatedRoute() {
    const { org } = Route.useParams()
    const navigate = useNavigate()
    const search = useSearch({ from: '/$org/group' })
    const setSearch = (patch: Record<string, unknown>) =>
        navigate({ to: '/$org/group', params: { org }, search: (prev: Record<string, unknown>) => ({ ...prev, ...patch }) as never, replace: true })
    return (
        <ConsolidatedView
            org={org}
            period={search.period ?? '90d'}
            level={search.level ?? 'agency'}
            family={search.family}
            kpi={search.kpi}
            onFamilyChange={(family) => setSearch({ family, kpi: undefined })}
            onKpiChange={(kpi) => setSearch({ kpi })}
        />
    )
}
